<template>
  <div
    v-if="hasAccess"
    class="fill-height"
  >
    <v-row class="d-flex justify-center">
      <v-col
        cols="12"
        md="3"
        sm="4"
      >
        <v-select
          v-model="selectedForm"
          :items="selectedFormOptions"
          label="Forms"
          outlined
        />
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center fill-height">
      <v-col
        cols="12"
      >
        <v-card
          class="mx-auto"
          max-width="1920"
        >
          <template v-if="currentForm">
            <v-card-title>{{ currentForm.name }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col
                  v-for="(item, key) in currentFormInputs"
                  :key="key"
                  cols="12"
                  sm="3"
                  md="3"
                >
                  <v-text-field
                    v-model="editedItem.inputs[`input_${key + 1}`]"
                    :label="item.name"
                    outlined
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  v-for="(item, key) in currentFormButtons"
                  :key="key"
                  cols="12"
                  sm="3"
                  md="3"
                >
                  <v-btn
                    x-large
                    @click="submit(key + 1)"
                  >
                    {{ item.name }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
          <template v-else>
            <v-row>
              <v-col
                cols="12"
                class="d-flex justify-center align-center"
              >
                <div class="headline primary--text my-3">
                  Select Form
                </div>
              </v-col>
            </v-row>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import apiUtil from '../utils/ApiUtil';

export default {
  data: () => {
    return {
      permissionsKey: 3,
      data: [],
      forms: [],
      selectedForm: null,
      currentForm: {},
      editedItem: {
        formId: null,
        buttonId: null,
        inputs: {},
      },
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
    selectedFormOptions() {
      if (this.forms.length <= 0) {
        return [];
      }

      const selectedFormOptions = [];
      for (const item of this.forms) {
        selectedFormOptions.push({ text: item.name, value: item.id });
      }

      return selectedFormOptions;
    },
    currentFormButtons() {
      if (Object.keys(this.currentForm).length === 0) {
        return [];
      }

      const filteredButtons = [];
      for (const item of this.currentForm.buttons) {
        if (item.name) {
          filteredButtons.push(item);
        }
      }

      return filteredButtons;
    },
    currentFormInputs() {
      if (Object.keys(this.currentForm).length === 0) {
        return [];
      }

      const filteredInputs = [];
      for (const item of this.currentForm.inputs) {
        if (item.name) {
          filteredInputs.push(item);
        }
      }

      return filteredInputs;
    },
  },
  watch: {
    selectedForm: {
      handler(newValue) {
        this.currentForm = this.forms.find((item) => { return item.id === newValue; });
      },
      immediate: true,
    },
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    await this.initialize();
    this.$store.dispatch('setGlobalLoading', false);
  },
  methods: {
    async initialize() {
      const result = await apiUtil.getAllForms();
      this.forms = result;
    },
    async submit(buttonId) {
      this.editedItem.formId = this.currentForm.id;
      this.editedItem.buttonId = buttonId;
      await apiUtil.saveFormList(this.editedItem);
    },
  },
};
</script>
